import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import MainLayout from '../../../../commons/layout/MainLayout/index';

import HeaderHs2 from '../../../../commons/components/Header/headerHs2';

import TabsComponent from '../../../../commons/components/Tabs/TabsComponent';
import ModalComponent from '../../../../commons/components/Modal/ModalComponent';
import ROUTERS from '../../../../commons/constans/router';
import { useCountdown } from '../../../../commons/customHooks/useCountdown';
import DialogComponent from '../../../../commons/components/Modal/DialogComponent';
import Barcode from 'react-barcode';
import _styles from './_styles.scss';
import PopComponent from '../../../../commons/components/Popup/PopupComponent';
import {
  currencyFormat,
  ploorPricePoint,
  priceFormat,
} from '../../../../utils/helpers';
import moment from 'moment';
import { chooseCoupon, getCoupon, getPoint } from '../../redux/actions/index';
import { useCouponFromGiftBoxPage } from '../../../Video/redux/actions/index';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';
import { useUser } from '../../../../commons/customHooks/Account';
import API, { ROUTES } from '../../../../commons/api/api';
// import ItemCouponComponent from "./ItemCouponComponent";
import ItemCouponComponent from '../../../../commons/components/Coupon/ItemCouponComponent';
import { QRCodeSVG, QRCode } from 'qrcode.react';
import { ReactComponent as PointBg } from '../../../../assets/images/point_bg.svg';
import { ReactComponent as IconPoint } from '../../../../assets/images/icon_point.svg';
import { ReactComponent as IconList } from '../../../../assets/images/icon_box_list_big_white.svg';
import { ReactComponent as VideoPoint } from '../../../../assets/images/video_point.svg';
import { ReactComponent as PointBrand } from '../../../../assets/images/point_brand01.svg';
import { ReactComponent as IconRightArrow } from '../../../../assets/images/icon_right_arrow.svg';
import { ReactComponent as CouponBgVideo } from '../../../../assets/images/couponbg01_s.svg';


const RESET_INTERVER = 300; // 300s = 5m * 60s/m

const formatTime = (time) =>
  `${String(Math.floor(time / 60)).padStart(2, '0')}:${String(
    time % 60
  ).padStart(2, '0')}`;

const Timer = ({ time }) => {
  const timeRemain = RESET_INTERVER - (time % RESET_INTERVER);
  let timerender = '00:00';
  if (time > 0) {
    timerender = formatTime(timeRemain);
  }
  return <>{timerender}</>;
};

const TimerCountDown = ({ time }) => {
  return (
    <>
      {time.minutes} : {time.seconds}
    </>
  );
};

function useQuery() {
  const { search } = useLocation();
  // return useMemo(() => new URLSearchParams(search), [search]);
  return search.includes('type=coupon');
}

const RenderContentBodyBarcode = (props) => {
  let time = props.time;
  let barcode = props.barcode ? props.barcode : 12345678909;
  let statusCompanyBarCode = props.statusCompany ? props.statusCompany : 1;
  return (
    <div className="modal-giftbox-scan-barcode">
      <div className="scan-barcode-body">
        <label className="scan-barcode-body__note">
          바코드를 키오스크 스캐너에 찍어주세요
        </label>
        <div className="scan-barcode-body__barcode">
          <label className="barcode-count-time">
            바코드 유효시간 : <TimerCountDown time={time} />{' '}
          </label>
          <Barcode
            className="barcode-icon"
            format="CODE128"
            value={barcode}
            width={3}
            height={150}
          />
          {/*<img className="barcode-icon" src="/images/scan_barcode.svg" />*/}
          {/*<label className="barcode-value">1234 1234 1234 1234</label>*/}
        </div>
        <div className="scan-barcode-body__link-to">
          <Link
            className="btn btn-link-to"
            to="/iframe"
            state={{
              url: 'http://playmoongu.com/store/search',
              path: ROUTERS.GIFTBOX_POINT + '?type=coupon',
            }}
          >
            {/* <button className="btn btn-link-to" onClick={()=>props.linkToLocation()}> */}
            <img
              className="btn-link-to-icon"
              src="/images/icon_location_point.svg"
            />
            <label className="btn-link-to-text white-space-norwrap">
              {statusCompanyBarCode == 1
                ? '키오스크 위치 보러가기'
                : '사용 매장 위치 찾기'}
            </label>
            {/* </button> */}
          </Link>
        </div>
      </div>
    </div>
  );
};

const GiftboxPageComponent = (props) => {
  var curent_datetime = moment(new Date().getTime())
    .zone('+0900')
    .format('YYYY-MM-DD HH:mm:ss');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  var point = props?.point ? props?.point : 0;
  var coupon = props?.coupon ? props?.coupon : [];
  var couponAdminSet = [];
  var countCouponNotKiot = 0;
  if (coupon.length > 0) {
    couponAdminSet = coupon.filter((item) => item.admin_id != null);
    countCouponNotKiot = coupon.filter(
      (item) => item?.coupon?.coupon_type != 'KIOSK_PHOTO'
    );
  }
  var countCoupon = coupon.filter((item) => item.expired_at >= curent_datetime);
  const [time, countDownEnd, resetTimer, startTimer, setStartTimer] =
    useCountdown(300);
  let query = useQuery();

  const [couponQrcode, setCouponQrcode] = useState([]);
  const [chooseCouponQrcode, setChooseCouponQrcode] = useState('');
  //modal
  const [modalState, setModalState] = useState(false);
  const [modalStateEndTime, setModalStateEndTime] = useState(false);
  const [modalStateUsePoint, setModalStateUsePoint] = useState(false);
  const [modalStateScanOffline, setModalStateScanOffline] = useState(false);
  const [modalStateTest, setModalStateTest] = useState(false);
  const [stateClassBgrModal, setStateClassBgrModal] = useState(false);
  const [activeIndexTab, setActiveIndexTab] = useState(query ? 1 : 0);

  const [randomCode, setrandomBarcode] = useState(100000000000);
  const [modalStateChangeToCoupon, setModalStateChangeToCoupon] =
    useState(false);
  const [stateTypeCoupon, setStateTypeCoupon] = useState('');
  const [pointPay, setPointPay] = useState(0);
  const [quantityOrderPoint, setQuantityOrderPoint] = useState(1);
  const [pointTypePlaymoongu, setPointTypePlaymoongu] = useState('');
  const [stateUseFullPoint, setStateUseFullPoint] = useState(false);
  const [statusSubmit, setStatusSubmit] = useState(false);
  const [modalConfirmChangeToCoupon, setModalConfirmChangeToCoupon] =
    useState(false);

  const [statusCompany, setStatusCompany] = useState(1);
  const [timer, setTime] = useState(1);
  const [useIdCoupon, setUseIdCoupon] = useState({});
  const { user } = useUser();
  // const [ point ] = usePoint();
  // const [ coupons ] = useCoupon();
  // console.log(props.isProcessingPoint, 'isProcessingPoint');
  useEffect(() => {
    // console.log(user, 'useruseruser');
    randomBarcode();
    getCouponTypeQrCode();
  }, []);

  useEffect(() => {
    if (countDownEnd) {
      setModalStateEndTime(true);
      setStateClassBgrModal(true);
    }
  }, [countDownEnd]);

  useEffect(() => {
    // console.log(+pointPay < point,'pointPay < point',pointPay , +point)
    checkStatusSubmit();
  }, [pointPay]);

  useEffect(() => {
    // console.log(+pointPay < point,'props?.point change111 < point',pointPay , +point)
    checkStatusSubmit();
  }, [props?.point]);

  const getCouponTypeQrCode = () => {
    let dataUserId = {
      userId: user?.uuid,
      // "userId": '84ae2656-3527-4a97-8cb1-e21646ee2049'
    };
    API.post(`${process.env.REACT_APP_API_JAVA_URL}/getCouponList`, dataUserId)
      .then((res) => {
        // console.log(res,'res 123',res?.data?.couponList)
        if (res?.data?.couponList && res?.data?.couponList.length > 0) {
          let dataTypeQrCode = res?.data?.couponList.filter(
            (item) => item.couponType == 'ONESHOT'
          );
          // console.log(dataTypeQrCode,'dataTypeQrCode')
          if (dataTypeQrCode.length > 0) {
            let dataCouponQrcodeFormat = [];
            dataTypeQrCode.map((item) => {
              item.coupon = { coupon_type: 'KIOSK_PHOTO', state: 'active' };
              item.admin_id = null;
              dataCouponQrcodeFormat.push(item);
            });
            setCouponQrcode(dataCouponQrcodeFormat);
          }
        }
      })
      .catch((error) => {
        // console.log(error,'catch error')
      });
  };

  const randomBarcode = (statusCompany = 1) => {
    const min = 100000000000;
    const max = 999999999999;
    const rand = min + parseInt(statusCompany) + Math.random() * (max - min);

    setrandomBarcode(Math.round(rand));
  };
  const checkStatusSubmit = () => {
    console.log('checkStatusSubmit');
    if (+pointPay <= +point && point != 0) {
      // console.log(stateTypeCoupon,'stateTypeCoupon123',pointPay , (pointPay != 0))
      if (stateTypeCoupon == 'PLAYMOONGU') {
        if (pointPay && pointPay != 0) {
          setStatusSubmit(true);
        } else {
          setStatusSubmit(false);
        }
      } else {
        setStatusSubmit(true);
      }
    } else {
      setStatusSubmit(false);
    }
  };

  const _closeModalEndTime = () => {
    setModalStateEndTime(!modalStateEndTime);
    resetTimer();
    randomBarcode();
    setStateClassBgrModal(false);
  };
  const _closeModalUsePoint = () => {
    setModalStateUsePoint(!modalStateUsePoint);
    setUseIdCoupon({});
  };

  const _handleCloseModal = () => {
    setModalState(!modalState);
    resetTimer();
    setStartTimer(true);
  };
  const refreshBarcode = () => {
    resetTimer();
    randomBarcode();
  };
  const openModalBarcodeCompany = (statusCompany) => {
    setModalState(true);
    setStatusCompany(statusCompany);
    setStartTimer(false);
    resetTimer();
    randomBarcode(statusCompany);
  };

  const useCouponModal = (data) => {
    if (data.coupon.coupon_type == 'PLAYMOONGU') {
      openModalBarcodeCompany(2);
    } else {
      setModalStateUsePoint(!modalStateUsePoint);
      setUseIdCoupon(data);
    }
  };

  const modalChangeToCoupon = (type) => {
    if (type === 'VIDEO_MSG' && process.env.REACT_APP_DISABLED_VIDEO_MESSAGE === 'true') {
			return;
    }
    // setStatusSubmit(false)
    setModalStateChangeToCoupon(true);
    setStateTypeCoupon(type);
    _pointPay(type);
    setQuantityOrderPoint(1);
    setPointTypePlaymoongu('');
    setStateUseFullPoint(false);

    let inputPointApply = document.getElementById('input-point-aplly');
    if (inputPointApply) {
      let hasInputPointApply =
        inputPointApply.classList.contains('input-point-aplly');
      if (hasInputPointApply) {
        document
          .getElementById('input-point-aplly')
          .classList.remove('input-point-aplly');
      }
    }
  };
  const RenderBackgroundCardCoupon = (type) => {
    let backgroundImageCard = '';
    switch (type) {
      case 'VIDEO_MSG':
        backgroundImageCard = '01';
        break;
      case 'KIOSK_PHOTO':
        backgroundImageCard = '02';
        break;
      default:
        backgroundImageCard = '03';
    }
    return backgroundImageCard;
  };
  const openModalScanOffline = (data = null) => {
    setModalStateScanOffline(!modalStateScanOffline);
    setChooseCouponQrcode(data);
  };

  const tabPoint = (
    <>
      <div className="tab-giftbox-point">
        <div className="tab-giftbox-point__my-point">
          <div className="my-point-content">
            <h3 className="my-point-content__title">MY 포인트</h3>
            <label className="my-point-content__description">
              제휴업체에 포인트를 사용할 수 있어요
            </label>
          </div>
          <div className="my-point-card">
            <img className="my-point-card__bgr" src="/images/point_bg.png" />
            {/* <div className="my-point-card__bgr">
              <PointBg />
            </div> */}
            <h3 className="my-point-card__info">
              <strong>{user?.nickname || ''}</strong> 회원님 보유포인트
            </h3>
            <div className="my-point-card__point">
              {/* <img
                className="my-point-card__point__icon"
                src="/images/icon_point.svg"
              /> */}
              <div className="my-point-card__point__icon">
                <IconPoint />
              </div>
              <label className="my-point-card__point__value">
                {props?.isProcessingPoint === true ? (
                  <SkeletonLoadingComponent
                    circle={false}
                    width="90px"
                    height="31px"
                  />
                ) : (
                  priceFormat(point)
                )}
              </label>
            </div>
            <button
              className="btn btn-primary my-point-card__history"
              onClick={() => navigate(ROUTERS.GIFTBOX_POINT_HISTORY)}
            >
              {/* <img
                className="my-point-card__history__icon"
                src="/images/icon_box_list_big_white.svg"
              /> */}
                <IconList />
              <label className="my-point-card__history__value m-0">
                내역보기
              </label>
            </button>
          </div>
        </div>
        <div className="tab-giftbox-point__use-point">
          <div className="use-point-content">
            <h3 className="use-point-content__title">쿠폰으로 교환하기</h3>
            <label className="use-point-content__description">
              포인트를 쿠폰으로 교환할 수 있어요.
            </label>
          </div>
          <div className="change-point-to-coupon">
            <div
              className={`change-point-to-coupon__item item-change-video ${
                process.env.REACT_APP_DISABLED_VIDEO_MESSAGE === 'true'
                  ? 'coming-soon'
                  : ''
              }`}
              onClick={() => modalChangeToCoupon('VIDEO_MSG')}
            >
              <img
                className="bgr-card"
                src={`/images/couponbg${RenderBackgroundCardCoupon(
                  'VIDEO_MSG'
                )}_s.svg`}
              />
              {/* <div className='bgr-card'>
                  <CouponBgVideo />
              </div> */}
              <div className="item-card">
                <div className="logo-change-to-coupon">
                  {/* <img src="/images/video_point.svg" /> */}
                  <span className='img-video'>
                    <VideoPoint />
                  </span>
                </div>
                <p className="name-coupon-change">
                  영상편지
                  <br />
                  무료 1회권
                </p>
                <label className="to-exchange">
                  교환하기 <i className="fa fa-chevron-right"></i>{' '}
                </label>
              </div>
            </div>
            <div
              className="change-point-to-coupon__item item-change-sphokidz"
              onClick={() => modalChangeToCoupon('KIOSK_PHOTO')}
            >
              <img
                className="bgr-card"
                src={`/images/couponbg${RenderBackgroundCardCoupon(
                  'KIOSK_PHOTO'
                )}_s.svg`}
              />
              <div className="item-card">
                <div className="logo-change-to-coupon">
                  {/* <img src="/images/point_brand01.svg" /> */}
                  <div className='img-logo'>
                    <PointBrand />
                  </div>
                </div>
                <p className="name-coupon-change">
                  키오스크
                  <br />
                  촬영 쿠폰
                </p>
                <label className="to-exchange">
                  교환하기 <i className="fa fa-chevron-right"></i>{' '}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  // console.log(coupon,'coupon4444',couponQrcode,chooseCouponQrcode)
  const tabCoupon = (
    <>
      <div className="tab-giftbox-coupon">
        <div className="tab-giftbox-coupon__my-voucher">
          <div className="coupon-content m-0">
            <h3 className="coupon-content__title">MY 쿠폰</h3>
          </div>
          {coupon.length == 0 ? (
            ''
          ) : (
            <div className="my-voucher-total mb-3">
              <label className="m-0">
                총 {coupon.length + couponQrcode.length}장
              </label>
            </div>
          )}
          {coupon.map((value, index) =>
            value.coupon?.state == 'active' ? (
              <ItemCouponComponent
                data={value}
                index={index}
                key={index}
                useCouponModal={useCouponModal}
                openModalScanOffline={openModalScanOffline}
              />
            ) : (
              ''
            )
          )}
          {couponQrcode.map((value, index) =>
            value.coupon?.state == 'active' ? (
              <ItemCouponComponent
                data={value}
                index={index}
                key={index}
                useCouponModal={useCouponModal}
                openModalScanOffline={openModalScanOffline}
              />
            ) : (
              ''
            )
          )}

          {coupon.length + couponQrcode.length <= 0 ? (
            <div className="data-not-found">
              <label className="data-not-found__text">
                보유하고 있는 쿠폰이 없어요.
              </label>
            </div>
          ) : (
            ''
          )}
          {coupon.length + couponQrcode.length == 0 ? (
            ''
          ) : (
            <div className="my-coupon-link">
              <Link
                to="/iframe"
                state={{
                  url: 'https://home.sphokidz.com/store',
                  path: ROUTERS.GIFTBOX_POINT + '?type=coupon',
                }}
              >
                <button className="btn btn-link-to">
                  <label className="m-0">스포키즈 키오스크 위치 확인하기</label>
                  {/* <img className="" src="/images/icon_right_arrow.svg" /> */}
                  <IconRightArrow />
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
  const backMenuHome = () => {
    navigate('/home');
  };
  const linkToStoreSphokid = () => {
    //   window.open("https://home.sphokidz.com/store", "_self");
    //   let url = `giftbox/point?type=coupon`
    //   window.nativeIsOpenListStore(true);
    // return <StorePageComponent />
    // const iframeSource = '<iframe src="https://home.sphokidz.com/store"></iframe>'
    // return (<div dangerouslySetInnerHTML={ {__html:  iframeSource}} />)

    navigate(ROUTERS.IFRAME, {
      state: {
        url: 'https://home.sphokidz.com/store',
        path: ROUTERS.GIFTBOX_POINT + '?type=coupon',
      },
    });
  };

  //   window.closeListStorePage = function() {
  //     alert('closeListStorePage')
  //     navigate(ROUTERS.GIFTBOX_POINT + '?type=coupon')
  //     setActiveIndexTab(1)
  //   }

  const linkToLocation = () => {
    if (statusCompany == 1) {
      window.open('https://home.sphokidz.com/store', '_self');
    } else {
      window.open('http://playmoongu.com/store/search', '_self');
    }
  };

  const _closeModalScanOffline = () => {
    setModalStateScanOffline(!modalStateScanOffline);
    getCouponTypeQrCode();
  };

  const handleConfirm = () => {
    navigate(ROUTERS.VIDEO_MESSAGE_MAKER);
    dispatch(chooseCoupon(useIdCoupon));
    dispatch(useCouponFromGiftBoxPage(useIdCoupon));
    _closeModalUsePoint();
  };
  const _closeModalStateTest = () => {
    setModalStateTest(!modalStateTest);
  };
  const changeTab = (e) => {
    if (e === activeIndexTab) {
      return;
    }
    if (activeIndexTab == 1) {
      navigate(ROUTERS.GIFTBOX_POINT + '?type=point');
      setActiveIndexTab(0);
    } else {
      navigate(ROUTERS.GIFTBOX_POINT + '?type=coupon');
      setActiveIndexTab(1);
      getCouponTypeQrCode();
    }
  };

  const _handleCloseModalChangeToCoupon = () => {
    setModalStateChangeToCoupon(false);
  };
  const _pointPay = (type) => {
    console.log('_pointPay', type);
    if (type == 'VIDEO_MSG') {
      setPointPay(5000);
    } else if (type == 'KIOSK_PHOTO') {
      setPointPay(3000);
    } else {
      setPointPay(0);
    }
  };
  const actionPayPoint = (action) => {
    if (action == 'plus') {
      setQuantityOrderPoint(quantityOrderPoint + 1);
      if (stateTypeCoupon == 'VIDEO_MSG') {
        setPointPay(pointPay + 5000);
      } else if (stateTypeCoupon == 'KIOSK_PHOTO') {
        setPointPay(pointPay + 3000);
      } else {
        setPointPay(pointPay + 1000);
      }
    } else {
      if (quantityOrderPoint == 1) {
        setQuantityOrderPoint(1);
      } else {
        setQuantityOrderPoint(quantityOrderPoint - 1);
        if (stateTypeCoupon == 'VIDEO_MSG') {
          setPointPay(pointPay - 5000);
        } else if (stateTypeCoupon == 'KIOSK_PHOTO') {
          setPointPay(pointPay - 3000);
        } else {
          setPointPay(pointPay - 1000);
        }
      }
    }
  };
  const useFullPoint = () => {
    if (point != 0 && +point >= 1000) {
      setPointTypePlaymoongu(
        +ploorPricePoint(point) / 1000 == 0
          ? ''
          : +ploorPricePoint(point) / 1000
      );
      document
        .getElementById('input-point-aplly')
        .classList.remove('input-point-aplly');
      setStateUseFullPoint(true);
      setPointPay(+ploorPricePoint(point));
    }
  };
  const handleInputChange = (event) => {
    let value = event.target.value;

    value = value.replace(/[^0-9]/g, '');
    if (!pointTypePlaymoongu) {
      value = value.replace(0, '');
    }

    setStateUseFullPoint(false);
    setTimeout(() => {
      if (value && value != 0) {
        document
          .getElementById('input-point-aplly')
          .classList.add('input-point-aplly');
      } else {
        document
          .getElementById('input-point-aplly')
          .classList.remove('input-point-aplly');
      }
    }, 100);
    setPointTypePlaymoongu(priceFormat(value));
    setPointPay(value * 1000);
  };
  const clearPointUse = () => {
    setPointTypePlaymoongu('');
    setStateUseFullPoint(false);
    setPointPay(0);
  };
  const submitChangePointToCoupon = () => {
    let checkstatusWithType = false;
    if (stateTypeCoupon == 'PLAYMOONGU') {
      checkstatusWithType = pointTypePlaymoongu ? true : false;
    } else {
      checkstatusWithType = +quantityOrderPoint > 0 ? true : false;
    }
    if (statusSubmit && checkstatusWithType) {
      let typeCoupon = '';
      if (stateTypeCoupon == 'KIOSK_PHOTO') {
        typeCoupon = 'ONESHOT';
      } else if (stateTypeCoupon == 'VIDEO_MSG') {
        typeCoupon = 'VIDEO_FREE';
      } else {
        typeCoupon = 'PLAYMOONGU';
      }
      setStatusSubmit(false);
      const formData = new FormData();
      formData.append(
        'qty',
        stateTypeCoupon == 'PLAYMOONGU'
          ? pointTypePlaymoongu
          : quantityOrderPoint
      );
      formData.append('coupon_type', typeCoupon);
      API.post(ROUTES.API_CHANGE_POINT_TO_COUPON, formData)
        .then((res) => {
          // console.log(res,'res 123 changePointToCoupon')
          setStatusSubmit(true);
          dispatch(getCoupon());
          setModalConfirmChangeToCoupon(true);
        })
        .catch((error) => {
          setStatusSubmit(true);
        });
    }
  };
  const _closeModalConfirm = () => {
    dispatch(getPoint());
    setModalConfirmChangeToCoupon(false);
    setModalStateChangeToCoupon(false);
    setQuantityOrderPoint(1);
    setPointTypePlaymoongu('');
    if (stateUseFullPoint) {
      setStateUseFullPoint(false);
    }
  };

  console.log(statusSubmit, 'statusSubmit');

  return (
    <MainLayout
      pageID={'giftbox'}
      displayBottomNav={true}
      activeNav={'GIFTBOX'}
    >
      <HeaderHs2
        title={'선물함'}
        labelLeft={true}
        labelRight={false}
        handleLabelLeft={backMenuHome}
      />
      <div
        className={`wrapper ` + (stateClassBgrModal ? ' hide-bgr-modal' : ' ')}
      >
        <TabsComponent
          tabHeadings={['포인트', '쿠폰']}
          tabContents={[tabPoint, tabCoupon]}
          activeIndex={activeIndexTab}
          handleChangeTab={changeTab}
          // handleChangeTab={handleChangeTab}
        />
        <ModalComponent
          id={'barcode'}
          show={modalState}
          heading={true}
          title={'영상편지 결제'}
          closeButton={true}
          handleClose={_handleCloseModal}
          swipeDown={false}
          type={'style-3'}
          dataValueModal3={currencyFormat(point) + 'P'}
          refreshBarcode={refreshBarcode}
          // logo={statusCompany == 1 ? '/images/point_detail_brand01.svg' : '/images/logo-playmoongu.svg'}
          logo={
            statusCompany == 1
              ? '/images/point_detail_brand01.svg'
              : '/images/point_brand02_playmoongu.svg'
          }
          iconClose={'/images/icon_close_black.svg'}
        >
          {modalState ? (
            <RenderContentBodyBarcode
              statusCompany={statusCompany}
              linkToLocation={linkToLocation}
              barcode={randomCode}
              time={time}
            />
          ) : (
            ''
          )}
        </ModalComponent>
        <DialogComponent
          id={'MD3'}
          show={modalStateEndTime}
          title={'알림'}
          // closeBtn={"확인"}
          handleClose={_closeModalEndTime}
          customBtn={'사용하기'}
          handleCustom={_closeModalEndTime}
          displayClose={true}
        >
          '영상 편지 무료 1회권'을
          <br /> 사용하시겠습니까?
        </DialogComponent>

        <DialogComponent
          id={'MD4'}
          show={modalStateUsePoint}
          title={'알림'}
          // closeBtn={"확인"}
          customBtn={'사용하기'}
          handleClose={_closeModalUsePoint}
          handleCustom={handleConfirm}
          displayClose={true}
          // iconRedirect={'/images/icon_next_btn_w.svg'}
        >
          '영상 편지 무료 1회권'을
          <br /> 사용하시겠습니까?
        </DialogComponent>

        <ModalComponent
          id={'show-qr-code'}
          show={modalStateScanOffline}
          heading={true}
          title={'오프라인 1회 무료 촬영권'}
          closeButton={true}
          handleClose={_closeModalScanOffline}
          overlay={false}
          swipeDown={true}
          type={'style-2'}
        >
          <div className="modal-scan-barcode-offline scan-barcode-offline">
            <label className="m-0 scan-barcode-offline__title">결제방법</label>
            <label className="m-0 scan-barcode-offline__description">
              스포카드 결제 &gt; 촬영권 결제
            </label>
            <div className="scan-barcode-offline__render-code">
              {/*<img className="" src="/images/icon_qr_black.svg" />*/}
              <QRCodeSVG
                value={chooseCouponQrcode?.couponNo}
                size={210}
                bgColor={'#ffffff'}
                fgColor={'#000000'}
                level={'H'}
                includeMargin={false}
              />
            </div>
          </div>
        </ModalComponent>

        <ModalComponent
          id={'change-to-coupon'}
          show={modalStateChangeToCoupon}
          heading={true}
          title={'쿠폰교환'}
          closeButton={true}
          handleClose={_handleCloseModalChangeToCoupon}
          swipeDown={false}
          type={'style-1'}
        >
          <div className="main-change-to-coupon">
            <div className="card-change-to-coupon">
              <img
                className="bg-card-coupon"
                src={`/images/couponbg${RenderBackgroundCardCoupon(
                  stateTypeCoupon
                )}_popup.svg`}
              />
              {stateTypeCoupon == 'VIDEO_MSG' ? (
                <div className="info-card">
                  <img src="/images/video_point.svg" />
                  <div className="type-change">
                    <p>영상편지 무료 1회권</p>
                    <p>5,000Point / 1개</p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {stateTypeCoupon == 'KIOSK_PHOTO' ? (
                <div className="info-card sphokidz">
                  <img src="/images/camera_popup.svg" />
                  <div className="type-change">
                    <p>스포키즈 키오스크 촬영 쿠폰</p>
                    <p>3,000Point / 1개</p>
                  </div>
                </div>
              ) : (
                ''
              )}
              {stateTypeCoupon == 'PLAYMOONGU' ? (
                <div className="info-card playmoongu">
                  <img src="/images/guya.svg" />
                  <div className="type-change">
                    <p>문구야놀자 쿠폰</p>
                    <p>1,000Point단위</p>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
            {stateTypeCoupon == 'PLAYMOONGU' ? (
              ''
            ) : (
              <div className="quantity-change">
                <label>쿠폰 수량</label>
                <div className="quantity-change__value">
                  <div className="item-value">
                    <label
                      className={`item-value__action `}
                      onClick={() => actionPayPoint('minus')}
                    >
                      <i
                        className={`fas fa-minus ${
                          quantityOrderPoint == 1 ? ' opacity-5' : ''
                        }`}
                      ></i>
                    </label>
                    <label className="item-value__number">
                      {quantityOrderPoint}
                    </label>
                    <label
                      className="item-value__action"
                      onClick={() => actionPayPoint('plus')}
                    >
                      <i className="fas fa-plus"></i>
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div className="info-point">
              <div className="info-point__hold info-point__item">
                <label className="info-point-label">보유 포인트</label>
                <label className="info-point-value">
                  {priceFormat(point)}P
                </label>
              </div>

              {stateTypeCoupon == 'PLAYMOONGU' ? (
                <div className="info-point__use info-point__item">
                  <label className="info-point-label">사용할 포인트</label>
                  <div className="use-point">
                    <div className="use-point__item">
                      <div
                        className={`input-value ${
                          stateUseFullPoint && point != 0
                            ? ' use-full-point'
                            : ''
                        }`}
                        id="input-point-aplly"
                      >
                        <input
                          readOnly={+point == 0 || +point < 1000 ? true : false}
                          type="number"
                          value={pointTypePlaymoongu || 0}
                          onChange={handleInputChange}
                        />
                        {stateUseFullPoint ? (
                          <div
                            className="clear-point"
                            onClick={() => clearPointUse()}
                          >
                            <img src="/images/icon_close_B-1.svg" />
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                      <label
                        className={`use-point-full ${
                          stateUseFullPoint || +point == 0 || +point < 1000
                            ? ' opacity-5'
                            : ''
                        }`}
                        onClick={() => useFullPoint()}
                      >
                        전액사용
                      </label>
                    </div>
                    <label className="use-point__alert">
                      포인트는 1,000P단위로만 사용 가능합니다.
                    </label>
                  </div>
                </div>
              ) : (
                <div className="info-point__pay info-point__item">
                  <label className="info-point-label">결제 포인트</label>
                  <label className="info-point-value">
                    {priceFormat(pointPay)}P
                  </label>
                </div>
              )}
            </div>
            {pointPay > point ? (
              <div className="alert-point-over">
                <div className="alert-point-over-item">
                  <img src="/images/icon_point_popup.svg" />
                  <label>보유 포인트가 부족합니다.</label>
                </div>
              </div>
            ) : (
              ''
            )}

            <div
              className={`btn-change-to-coupon  ${
                !statusSubmit ? ' disabled' : ''
              }`}
              onClick={() => submitChangePointToCoupon()}
            >
              <button className="btn">교환하기</button>
            </div>
          </div>
        </ModalComponent>

        <DialogComponent
          className={'modal-confirm-change-coupon'}
          show={modalConfirmChangeToCoupon}
          title={'알림'}
          customBtn={'확인'}
          handleCustom={_closeModalConfirm}
        >
          교환이 완료되었습니다.
        </DialogComponent>
      </div>
    </MainLayout>
  );
};

export default GiftboxPageComponent;
